import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { SettlementPaymentFormData } from "@/formTypes/SettlementPaymentDataType";

export type SettlementPaymentDataType = Partial<ApiSchema["SettlementPayment"]["type"] & SettlementPaymentFormData>;
class Api extends GenericModelApi<"SettlementPayment", SettlementPaymentDataType> {

    async fetchAllByRecibe(recibeId: string): Promise<FetchResponse<SettlementPaymentDataType>> {
        const fetchFunction = ApiClient.models[this.modelName].listSettlementPaymentByRecibeId;

        const { data, errors, nextToken: nt } = await fetchFunction({
            recibeId: recibeId
        }, {
            limit: 1000
        });

        if (errors) {
            throw new ApiError("Error al obtener los abonos liquidacion por recibo", "API_ERROR", errors);
        }

        return { items: data };
    }

}
export const SettlementPaymentApi = new Api("SettlementPayment", "descripcion");